export default "__VITE_ASSET__188bcda8__"